import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { LangProvider } from "@/lib/i18n";
import HomePage from "@/pages/HomePage";
import SalmoPage from "@/pages/SalmoPage";
import CategoriaPage from "@/pages/CategoriaPage";
import TodosOsSalmosPage from "@/pages/TodosOsSalmosPage";
import SobrePage from "@/pages/SobrePage";

function App() {
  return (
    <div className="App min-h-screen bg-[var(--cor-fundo)] text-[var(--cor-texto)] grain-overlay">
      <BrowserRouter>
        <LangProvider>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/salmo/:numero" element={<SalmoPage />} />
              <Route path="/categoria/:slug" element={<CategoriaPage />} />
              <Route path="/salmos" element={<TodosOsSalmosPage />} />
              <Route path="/sobre" element={<SobrePage />} />
            </Routes>
          </main>
          <Footer />
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
